// @flow
import React from 'react'
import styled, { css } from 'styled-components'
import Colors from 'components/styles/colors'
import { mediaMax, mediaMin } from 'frontend_core/dist/styles/media'
import {
  fontSize,
  spacing,
  borderRadius,
} from 'frontend_core/dist/styles/variables'

const DateWrapper = styled.div`
  margin-bottom: ${spacing.small_2}px;
  text-align: center;
`
const Date = styled.span`
  display: inline-block;
  color: ${Colors.gray9};
  font-size: ${fontSize.small}px;
  text-align: center;
`
const ChatOutLine = styled.div`
  padding: ${spacing.medium}px;
  border: 1px solid ${Colors.grayD};
  border-radius: ${borderRadius}px;
  ${mediaMin.phone`
    padding: ${spacing.medium_2}px;
  `};
`
const TitleWrapper = styled.div`
  padding-bottom: ${spacing.small_3}px;
  border-bottom: 1px solid ${Colors.grayE};
`
const Title = styled.h1`
  font-size: ${fontSize.small_3}px;
  font-weight: bold;
  line-height: 1.333;
  ${mediaMin.phone`
    font-size: ${fontSize.medium}px;
  `};
`
const ChatOutLineContent = styled.div`
  display: table;
  table-layout: fixed;
  width: 100%;
  margin-top: ${spacing.small_3}px;
  ${({ isBorder }) =>
    isBorder &&
    css`
      border-top: 1px dashed ${Colors.grayE};
    `};
`
const ApplicationDetaiContent = styled.div`
  display: table;
  table-layout: fixed;
  width: 100%;
  margin-top: ${spacing.small_3}px;
  ${mediaMax.phone`
    padding-top: ${spacing.small_3}px;
    border-top: 1px dashed ${Colors.grayE};
  `};
`
const ApplicationDetailHead = styled.div`
  ${mediaMin.phone`
    display: table-cell;
    width: 120px;
`};
`
const ApplicationDetaiBody = styled.div`
  margin-top: ${spacing.small_2}px;
  ${mediaMin.phone`
    display: table-cell;
    margin-top: 0;
  `};
`
const ChatOutLineHead = styled.div`
  width: 60px;
  display: table-cell;
  ${mediaMin.phone`
    width: 120px;
  `};
`
const ChatOutLineBody = styled.div`
  display: table-cell;
`
const ChatOutLineHeadTitle = styled.p`
  font-size: ${fontSize.small_3}px;
  line-height: 1.5;
  font-weight: bold;
`
const ChatOutLineBodyText = styled.p`
  font-size: ${fontSize.small_3}px;
  line-height: 1.5;
`
const Guide = styled.p`
  margin-top: ${spacing.small_3}px;
  color: ${Colors.red};
  font-size: ${fontSize.small}px;
  line-height: 1.4;
`

type PropTypes = {
  time: string,
  purposeUse: string,
  utilityForm: string,
  numberOfPeople: string,
  applicationDetail: string,
  isInquiry: boolean,
}

export default (props: PropTypes) => (
  <div>
    <DateWrapper>
      <Date>{props.time}</Date>
    </DateWrapper>
    <ChatOutLine>
      <TitleWrapper>
        <Title>
          {props.isInquiry
            ? i18n.t('page.shared.inquiry')
            : i18n.t('page.shared.reservation_request')}
        </Title>
      </TitleWrapper>
      <ChatOutLineContent>
        <ChatOutLineHead>
          <ChatOutLineHeadTitle>
            {i18n.t('page.dashboard.reservation.purposeUse')}
          </ChatOutLineHeadTitle>
        </ChatOutLineHead>
        <ChatOutLineBody>
          <ChatOutLineBodyText>{props.purposeUse}</ChatOutLineBodyText>
        </ChatOutLineBody>
      </ChatOutLineContent>
      <ChatOutLineContent>
        <ChatOutLineHead>
          <ChatOutLineHeadTitle>
            {i18n.t('page.dashboard.reservation.utilityForm')}
          </ChatOutLineHeadTitle>
        </ChatOutLineHead>
        <ChatOutLineBody>
          <ChatOutLineBodyText>{props.utilityForm}</ChatOutLineBodyText>
        </ChatOutLineBody>
      </ChatOutLineContent>
      <ChatOutLineContent>
        <ChatOutLineHead>
          <ChatOutLineHeadTitle>
            {i18n.t('page.dashboard.reservation.numberOfPeople')}
          </ChatOutLineHeadTitle>
        </ChatOutLineHead>
        <ChatOutLineBody>
          <ChatOutLineBodyText>{props.numberOfPeople}</ChatOutLineBodyText>
        </ChatOutLineBody>
      </ChatOutLineContent>
      {props.applicationDetail && (
        <ApplicationDetaiContent>
          <ApplicationDetailHead>
            <ChatOutLineHeadTitle>
              {i18n.t('page.dashboard.reservation.applicationDetail')}
            </ChatOutLineHeadTitle>
          </ApplicationDetailHead>
          <ApplicationDetaiBody>
            <ChatOutLineBodyText>{props.applicationDetail}</ChatOutLineBodyText>
          </ApplicationDetaiBody>
        </ApplicationDetaiContent>
      )}
    </ChatOutLine>
    <Guide>{i18n.t('page.dashboard.reservation.messageGuide')}</Guide>
    {props.isInquiry && (
      <React.Fragment>
        <Guide>
          {i18n.t('page.dashboard.reservation.messageGuideForInquiry1')}
        </Guide>
        <Guide>
          {i18n.t('page.dashboard.reservation.messageGuideForInquiry2')}
        </Guide>
      </React.Fragment>
    )}
  </div>
)



// WEBPACK FOOTER //
// ./src/components/molecules/message/MessageOutline.jsx